<template>
  <v-card v-if="screener">
    <template>
      <v-card-title tile>
        <v-layout  row wrap class="pt-2">
          <v-flex xs12 sm6 md5 class="text-xs-center ">
          <v-text-field
            v-model="search"
            color="primary"
            prepend-inner-icon="search"
            :label="$t('screener.search.title')"
            single-line
            hide-details
          ></v-text-field>
         </v-flex>
         <v-flex xs12 sm6 md4 class="text-xs-center" >
            <v-select

              class="pl-2"
              v-model="participants_type"
              :items="participants_filter"
              item-text="text"
              item-value="value"
              @change="getDataFromApi"
              :label="$t('screener.filter.title')"
              :clearable="true"
            ></v-select>
            </v-flex>
          </v-layout>
        <v-spacer></v-spacer>
        <v-menu offset-y v-if="!screener.is_vod_event">
          <template v-slot:activator="{ on }">
            <v-btn :disabled="!selected.length" color="primary" v-on="on">
              {{ $t("screener.btn.more") }}
              <v-icon class="pl-1">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-tile @click="sendVerificationsEmails()">
              <v-list-tile-title>
                <v-icon class="pr-2">mdi-email</v-icon>
                {{ $t('screener.btn.send.verification') }}
              </v-list-tile-title>
            </v-list-tile>-->
            <v-list-tile @click="sendReminders()">
              <v-list-tile-title>
                <v-icon class="pr-2">mdi-clock</v-icon>
                {{ $t("screener.btn.send.reminder") }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn v-if="!screener.is_vod_event" class="mr-0" @click.stop="initiateImport()" color="primary">
          <v-icon small class="pr-1">$vuetify.icons.rms_upload</v-icon>
           {{$t('screener.btn.import')}}
        </v-btn>
        <v-btn :disabled="!consumers.data.length" class="mr-0" @click="download" color="primary">
          <v-icon small class="pr-1">$vuetify.icons.rms_media_download</v-icon>
          {{ $t("screener.btn.download") }}
        </v-btn>
        <v-btn
        class="mr-0"
          color="primary"
          v-if="(userRoleInCompany > DEFINES.ROLE_MEMBER) && (!isScreeningPaid(screener))"
          outlined
          @click="openCreateDialog"
          >{{ $t("rms.button.create") }}</v-btn
        >
        <!-- Delete all registrants btn -->
        <ConfirmationDialog
          :desc="'screener.registrant.remove.confirmation.description'"
          :action="
            getDialogAction(
              null,
              'rms_delete',
              'error',
              'screener.btn.delete_all',
              'deleteAll'
            )
          "
          :headline="'screener.registrant.all.remove.confirmation.heading'"
          :button_type="'button'"
        ></ConfirmationDialog>
      </v-card-title>

      <v-dialog v-model="createDialog" max-width="50vmin" flat>
        <v-card flat class="pa-3">
          <v-card-title>
            <div class="title">Create a consumer</div>
          </v-card-title>

          <v-card-text>
            <v-form ref="consumerForm">
              <v-text-field
                :rules="[rules.required, rules.email]"
                label="Enter the email"
                v-model="consumer_email"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-3">
            <v-spacer></v-spacer>
            <v-btn
              dark
              color="grey"
              @click="(createDialog = false), (consumer_email = null)"
              >{{ $t("rms.button.cancel") }}</v-btn
            >
            <v-btn dark color="primary" @click="create">
              {{ $t("rms.button.create") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Registrants statistics -->
      <v-card-text
        v-if="consumers && consumers.total"
        class="text-xs-center px-0"
      >
        <v-layout row wrap class="grey lighten-4 pa-3">
          <!-- Total -->
          <v-flex xs2>
            <div>
              <div class="greyDarken3--text display-2">
                {{ consumers.total }}
              </div>
              <div
                class="subheading grey--text text--darken-3 font-weight-thin"
              >
                {{ $t("screener.admin.total_participants") }}
              </div>
            </div>
          </v-flex>
          <!--Imported -->
          <v-divider v-if="total_imported_count" vertical></v-divider>
          <v-flex xs2 v-if="total_imported_count">
            <div>
              <div class="greyDarken3--text display-2">
                {{ total_imported_count }}
              </div>
              <div
                class="subheading grey--text text--darken-3 font-weight-thin"
              >
                {{ $t("screener.admin.imported_participants") }}
              </div>
            </div>
          </v-flex>
          <!-- Registered with Magic Link -->
          <v-divider v-if="total_enrolled_with_link" vertical></v-divider>
          <v-flex xs2 v-if="total_enrolled_with_link">
            <div>
              <div class="greyDarken3--text display-2">
                {{ total_enrolled_with_link }}
              </div>
              <div
                class="subheading grey--text text--darken-3 font-weight-thin"
              >
                Registered with Magic Link
              </div>
            </div>
          </v-flex>
          <!-- Screening Attended -->
          <v-divider v-if="screening_attended_count" vertical></v-divider>
          <v-flex xs2 v-if="screening_attended_count">
            <div>
              <div class="greyDarken3--text display-2">
                {{ screening_attended_count }}
              </div>
              <div
                class="subheading grey--text text--darken-3 font-weight-thin"
              >
                {{ $t("screener.admin.screening_attended") }}
              </div>
            </div>
          </v-flex>
          <!-- Totol Purchased -->
          <v-divider
            v-if="isScreeningPaid(screener) && total_purchased_count"
            vertical
          ></v-divider>
          <v-flex xs2 v-if="isScreeningPaid(screener) && total_purchased_count">
            <div>
              <div class="greyDarken3--text display-2">
                {{ total_purchased_count }}
              </div>
              <div
                class="subheading grey--text text--darken-3 font-weight-thin"
              >
                {{ $t("screener.admin.screening_total_purchased") }}
              </div>
            </div>
          </v-flex>
          <!-- Live Counter -->
          <!-- <v-divider
            v-if="screener && screener.live_counter"
            vertical
          ></v-divider>
          <v-flex xs2 v-if="screener && screener.live_counter">
            <div>
              <div class="red--text display-2">{{ screener.live_counter }}</div>
              <div class="subheading red--text text--darken-3 font-weight-thin">
                {{ $t("screener.admin.live_counter") }}
              </div>
            </div>
          </v-flex> -->

          <!-- Live Counter Using Firebase -->
          <template >
            <v-divider
              vertical
            ></v-divider>
            <v-flex xs2 v-if="liveUsers && liveUsers.length">
              <div>
                <div class="red--text display-2">{{ liveUsers.length }}</div>
                <div class="subheading red--text text--darken-3 font-weight-thin">
                  {{ $t("screener.admin.live_counter") }}
                </div>
              </div>
            </v-flex>
          </template>

        </v-layout>
      </v-card-text>

      <v-data-table
        v-model="selected"
        :headers="table_headers"
        :items="consumers.data"
        v-bind:pagination.sync="pagination"
        :total-items="consumers.total"
        :rowsPerPageItems="[25]"
        select-all
      >
        <template v-slot:headers="props">
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              ></v-checkbox>
            </th>
            <th class="text-xs-left">{{$t('vod.registrants.table.column.sn')}}</th>
            <th class="text-xs-left">{{$t('vod.registrants.table.column.email')}}</th>
            <th class="text-xs-left">{{$t('vod.registrants.table.column.status')}}</th>
            <th class="text-xs-left" v-if="!screener.is_vod_event">Registered with Import</th>
            <th class="text-xs-left" v-if="!screener.is_vod_event">Registered with Magic Link</th>
            <th class="text-xs-left" v-if="!screener.is_vod_event">{{$t('vod.registrants.table.column.purchased')}}</th>
            <th class="text-xs-left" v-if="!screener.is_vod_event" >{{$t('vod.registrants.table.column.reminder_sent')}}</th>
            <th class="text-xs-left">{{$t('screener.admin.screening_attended')}}</th>
            <th class="text-xs-left" v-if="screener.is_vod_event">{{$t('vod.registrants.table.column.start_end_date')}}</th>
            <th class="text-xs-left">{{$t('vod.registrants.table.column.created_at')}}</th>
            <th class="text-xs-left">{{$t('vod.registrants.table.column.actions')}}</th>
          </tr>
        </template>

        <template v-slot:items="props">
          <tr
            :active="props.selected"
            @click="props.selected = !props.selected"
          >
            <td width="2%" class="text-xs-left">
              <v-checkbox
                :input-value="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td width="6%" class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <td class="text-xs-left">
              <div class="status-indicator">
                <!-- Online User -->
                <template v-if="liveUsers && liveUsers.includes(props.item.id.toString())">
                  <div class="dot online"></div>
                  <span class="status-text">Online</span>
                </template>
                <!-- Offline User -->
                <template v-else>
                  <div class="dot offline"></div>
                  <span class="status-text">Offline</span>
                </template>

              </div>
            </td>
            <td v-if="!screener.is_vod_event" class="text-xs-left">
              <v-icon v-if="props.item.pivot.is_imported" color="success"
                >mdi-check</v-icon
              >
              <v-icon v-else color="error">mdi-window-close</v-icon>
            </td>
            <td v-if="!screener.is_vod_event" class="text-xs-left">
              <v-icon v-if="props.item.pivot.enrolled_with_magic_link" color="success"
                >mdi-check</v-icon
              >
              <v-icon v-else color="error">mdi-window-close</v-icon>
            </td>
            <td v-if="!screener.is_vod_event" width="5%" class="text-xs-left">
              <template v-if="isScreeningPaid(screener)">
                <v-icon v-if="props.item.pivot.is_purchased" color="success"
                  >mdi-check</v-icon
                >
                <v-icon v-else color="error">mdi-window-close</v-icon>
              </template>
              <template v-else>
                <span>{{ $t("screener.not_applicable") }}</span>
              </template>
            </td>
            <td v-if="!screener.is_vod_event" width="2%" class="text-xs-left">
              <v-icon v-if="props.item.pivot.reminder_sent" color="success"
                >mdi-check</v-icon
              >
              <v-icon v-else color="error">mdi-window-close</v-icon>
            </td>
            <td width="2%" class="text-xs-left">
              <v-icon v-if="props.item.pivot.screening_attended" color="success"
                >mdi-check</v-icon
              >
              <v-icon v-else color="error">mdi-window-close</v-icon>
            </td>
            <td v-if="screener.is_vod_event" width="15%" class="text-xs-left">
              <span v-if="props.item.pivot.event_starts_at">{{ fmtTime(props.item.pivot.event_starts_at) }}
                (to)
                {{ fmtTime(props.item.pivot.event_ends_at) }}</span>
              <span v-else>NA</span>
            </td>
            <td width="15%" class="text-xs-left">
              {{ moment(props.item.created_at).format("DD MMM YYYY, HH:MM") }}
            </td>
            <td width="20%" class="text-xs-left">
              <v-tooltip v-if="user_role == DEFINES.USER_ROLE_SUPER_ADMIN" slot="append" top color="white">
                <v-btn
                  slot="activator"
                  icon
                  small
                  dark
                  @click.stop="showFilmAnalytics(props.item)"
                >
                  <v-icon color="secondary"
                    >$vuetify.icons.chart_bar</v-icon
                  >
                </v-btn>
                <span class="greyDarken3--text body-1">
                  Show analytics
                </span>
              </v-tooltip>
              <v-tooltip slot="append" top color="white">
                <v-btn
                  slot="activator"
                  icon
                  small
                  dark
                  @click="showPassword(props.item.id)"
                >
                  <v-icon color="secondary"
                    >$vuetify.icons.rms_visibility</v-icon
                  >
                </v-btn>
                <span class="greyDarken3--text body-1">
                  {{ $t("screener.tooltip.show_password") }}
                </span>
              </v-tooltip>
              <!-- Delete registrant btn -->
              <ConfirmationDialog
                :desc="'screener.registrant.remove.confirmation.description'"
                :action="
                  getDialogAction(
                    props.item.id,
                    'rms_delete',
                    'error',
                    'delete'
                  )
                "
                :headline="'screener.registrant.remove.confirmation.heading'"
                :button_type="'icon'"
              ></ConfirmationDialog>
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            {{ $t("rms.alert.search_not_found") }}
          </v-alert>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="showPasswordDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">
          {{ $t("screener.consumer.password.title") }}
        </v-card-title>
        <v-card-text v-if="consumerPassword" class="text-xs-center">
          <div class="headline">{{ consumerPassword }}</div>
        </v-card-text>
        <v-card-text v-else>
          {{ $t("screener.save.password_not_generated") }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="lightteal"
            dark
            outline
            @click="
              $copyText(consumerPassword);
              showPasswordDialog = false;
              consumerPassword = null;
            "
            >{{ $t("screener.btn.copy") }}</v-btn
          >
          <v-btn
            color="lightteal"
            dark
            outline
            @click="
              showPasswordDialog = false;
              consumerPassword = null;
            "
            >{{ $t("screener.btn.ok") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
      <ImportConsumers v-if="importDialog" :importDialog.sync="importDialog" :screener="screener"></ImportConsumers>
      <ConsumerFilmAnalytics
          v-if="consumerFilmAnalyticsDialog.isVisible"
          :dialog="consumerFilmAnalyticsDialog.isVisible"
          :consumer="consumerFilmAnalyticsDialog.consumer"
          :film="consumerFilmAnalyticsDialog.film"
          :analytics="consumerFilmAnalyticsDialog.analytics"
          @onClose="resetAnalyticsDialog()"
      />
  </v-card>
</template>
<script>
import ConfirmationDialog from "@/components/ConfirmationDialog";
import i18n from "@/i18n";
import { mapGetters, mapState } from "vuex";
import rules from "@/validation";
import {utcToTz} from '@/helper';
import ImportConsumers from '@/components/screener/ImportConsumers'
import ConsumerFilmAnalytics from '@/components/analytics/ConsumerFilmAnalytics'
import * as firebase from "firebase";

export default {
  data() {
    return {
      rules,
      consumers: {
        data: [],
      },
      createDialog: false,
      consumer_email: null,
      search: "",
      confirmation: false,
      deleteAllConfirmation: false,
      showPasswordDialog: false,
      table_headers: [
        { text: "SN", align: "left", sortable: false },
        {
          text: "Email",
          sortable: false,
          align: "left",
          value: "email",
        },
        {
          text: "Status",
          align: "left",
        },
        {
          text: "Registered via import",
          align: "left",
          sortable: false,
          value: "is_imported",
        },
        {
          text: "Purchased",
          align: "left",
          sortable: false,
          value: "is_purchased",
        },
        {
          text: "Reminder Sent",
          align: "left",
          sortable: false,
          value: "reminder_sent",
        },
        {
          text: "Screening Attended",
          align: "left",
          sortable: false,
          value: "screening_attended",
        },
        {
          text: "Created At",
          align: "left",
          sortable: false,
          value: "created_at",
        },
        {
          text: "Action",
          align: "left",
          value: "delete",
          sortable: false,
        },
      ],
      consumer_id: null,
      pagination: {
        sortBy: "created_at",
        descending: true,
        rowsPerPage: 25,
        page: 1,
      },
      participants_type:null,
      participants_filter:[
        {
          text: 'Purchased',
          value: 'is_purchased',
        },
        {
          text: 'Attended',
          value: 'screening_attended',
        },
        {
          text: 'Imported',
          value: 'is_imported',
        },
        {
          text: 'Reminder Sent',
          value: 'reminder_sent',
        },
      ],
      selected: [],
      consumerPassword: null,
      screening_attended_count: null,
      total_purchased_count: null,
      total_enrolled_count: null,
      total_imported_count:null,
      total_participants:null,
      total_enrolled_with_link:null,
      importDialog:false,
      liveUsers: null,
      consumerFilmAnalyticsDialog: {
        isVisible: false,
        consumer: null,
        analytics: null,
        film: null
      }
    };
  },
  components: { ConfirmationDialog,ImportConsumers, ConsumerFilmAnalytics },
  watch: {
    pagination: {
      handler() {
        if (this.$route.params.screener_id) this.getDataFromApi();
      },
      deep: true,
    },
    search() {
      if (this.search.length > 2 && this.$route.params.screener_id) {
        this.getDataFromApi();
      }
      if (!this.search.length && this.$route.params.screener_id) {
        this.getDataFromApi();
      }
    },
  },
  created() {
    if (this.$route.params.screener_id != undefined) {
      this.getDataFromApi();
    }
    this.bindLiveCounterWithFBase(this.$route.params.screener_id)
  },
  computed: {
    ...mapState({
      user_role: (state) => state.user.profile.role,
    }),
    ...mapGetters({
      isScreeningPaid: "screener/isScreeningPaid",
      selected_company_id: "company/getSelected",
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
    }),
    screener() {
      //FIXME::Temporary fix for live counter
      return this.$store.getters["screener/getScreener"](
        this.$route.params.screener_id
      );
    },
  },
  methods: {
     initiateImport(){
      this.importDialog = true;
    },
    async remove(consumer_id) {
      try {
        var result = await this.$store.dispatch("consumer/detachConsumer", {
          consumer_id: consumer_id,
          screener_id: this.$route.params.screener_id,
        });
        this.$store.dispatch("app/showMessage", {
          message: "Registrant removed successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
        this.getDataFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      } finally {
        this.confirmation = false;
      }
    },
    async deleteAll() {
      try {
        var result = await this.$store.dispatch("consumer/detachAllConsumer", {
          screener_id: this.$route.params.screener_id,
        });
        this.$store.dispatch("app/showMessage", {
          message: "Registrants removed successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
        this.getDataFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      } finally {
        this.confirmation = false;
      }
    },

    async getDataFromApi() {
      try {
        var result = await this.$store.dispatch("consumer/getConsumerList", {
          screener_id: this.$route.params.screener_id,
          page: this.pagination.page,
          search: this.search,
          participants_type:this.participants_type,
        });
        this.consumers = result.consumers;
        this.screening_attended_count = result.screening_attended_count;
        this.total_purchased_count = result.total_purchased_count;
        this.total_enrolled_count = result.total_enrolled_count;
        this.total_imported_count = result.total_imported_count;
        this.total_participants = result.total_participants;
        this.total_enrolled_with_link = result.total_enrolled_with_link
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    async showPassword(consumer_id) {
      try {
        this.consumerPassword = null;
        var result = await this.$store.dispatch("consumer/showPassword", {
          screener_id: this.$route.params.screener_id,
          id: consumer_id,
        });

        this.consumerPassword = result.password;
        this.showPasswordDialog = true;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    async sendVerificationsEmails() {
      // try {
      //   var result = await this.$store.dispatch(
      //     "customer/sendVerificationsEmails",
      //     {
      //       customers: this.getSelectedConsumerIds(this.selected),
      //       screener_id: this.$route.params.screener_id
      //     }
      //   );
      //   this.$store.dispatch("app/showMessage", {
      //     message: i18n.t(
      //       "screener.customers.send.verification.success.message"
      //     ),
      //     color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
      //   });
      // } catch (error) {
      //   this.$store.dispatch("app/showMessage", {
      //     message: error.message,
      //     color: this.DEFINES.SNACKBAR_ERROR_COLOR
      //   });
      // }
    },

    async sendReminders() {
      try {
        var result = await this.$store.dispatch("consumer/sendReminders", {
          consumers: this.getSelectedConsumerIds(this.selected),
          screener_id: this.$route.params.screener_id,
        });
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("screener.consumers.send.reminder.success.message"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    async create() {
      try {
        if (!this.$refs.consumerForm.validate()) {
          return false;
        }
        var result = await this.$store.dispatch("consumer/createByAdmin", {
          screener_id: this.$route.params.screener_id,
          email: this.consumer_email,
          company_id: this.$route.params.company_id,
        });
        this.getDataFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      } finally {
        this.createDialog = false;
      }
    },

    async download() {
      try {
        var result = await this.$store.dispatch(
          "screener/downloadAllConsumers",
          {
            screener_id: this.$route.params.screener_id,
          }
        );
        window.open(result.link, "_blank");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.consumers.data.slice();
    },
    getSelectedConsumerIds(selected_consumers) {
      return selected_consumers.map((consumer) => consumer.id);
    },

    openCreateDialog() {
      this.createDialog = true;
      this.consumer_email = null;
    },

    getDialogAction(
      consumer_id = null,
      btn_icon,
      btn_color,
      btn_lable,
      action
    ) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        button_label: btn_lable,
        no_outline: true,
        method: action == "deleteAll" ? this.deleteAll : this.remove,
        payload: consumer_id,
      };
    },
    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, 'MMMM Do YYYY, h:mm a');
    },
    async bindLiveCounterWithFBase(screenerId) {
        let _this = this
        return firebase.database().ref(`/live_users/${screenerId}`).on('value', function(snapshot) {
            _this.liveUsers = snapshot.exists() ? Object.keys(snapshot.val()): null;
            _this.getDataFromApi()
        })
    },

    async showFilmAnalytics(consumer){
      let film = this.screener.films[0];
      await this.$store.dispatch('analytics/fetchConsumerAnalyticsOnFilm',{
        consumerId: consumer.id,
        filmId: film.id
      })
      .then((res) => {
        this.consumerFilmAnalyticsDialog.film = film;
        this.consumerFilmAnalyticsDialog.analytics = res.analytics;
        this.consumerFilmAnalyticsDialog.consumer = consumer;
        this.consumerFilmAnalyticsDialog.isVisible = true;
      })
    },

    resetAnalyticsDialog(){
      this.consumerFilmAnalyticsDialog.isVisible = false;
      this.consumerFilmAnalyticsDialog.film = null;
      this.consumerFilmAnalyticsDialog.analytics = null;
      this.consumerFilmAnalyticsDialog.consumer = null;
    }
  },
};
</script>
<style scoped>
.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px; /* Spacing between dot and text */
  font-size: 14px;
}

/* Base style for the dot */
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

/* Green dot for online */
.online {
  background-color: #4caf50;
  animation: blink 1s infinite alternate; /* Blink animation */
}

/* Red dot for offline */
.offline {
  background-color: #f44336;
}

/* Blink animation for the green dot */
@keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}

/* Text next to the dot */
.status-text {
  color: #555;
}
</style>

